import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import BreakingNewsBar from "./BreakingNewsBar";
import WeatherBar from "./WeatherBar";
import AdSlot from "@/components/ads/AdSlot";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-lightgray text-blueblack">
      <WeatherBar />
      <Header />
      <BreakingNewsBar />
      <AdSlot slot="below-menu" className="container-wide my-4 flex justify-center" />
      <main className="flex-1">{children}</main>
      <AdSlot slot="footer" className="container-wide my-6 flex justify-center" />
      <Footer />
      <AdSlot slot="floating" floating />
      <AdSlot slot="mobile-exclusive" className="lg:hidden container-wide my-4 flex justify-center" />
    </div>
  );
}
